import React from "react";
import { SVGProps } from "react";

const PaymentIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3.33333 4.1665H16.6667C17.5871 4.1665 18.3333 4.9127 18.3333 5.83317V14.1665C18.3333 15.087 17.5871 15.8332 16.6667 15.8332H3.33333C2.41286 15.8332 1.66667 15.087 1.66667 14.1665V5.83317C1.66667 4.9127 2.41286 4.1665 3.33333 4.1665V4.1665" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M1.66667 8.3335H18.3333" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default PaymentIcon;
